import { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useRouter } from 'next/router';

import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import { kolVideo } from '@/constants/blade';

import css from './index.module.scss';
import request from '@/request';
import NextImage from '@/components/NextImage';
import { useLang } from '@/i18n';
import { useGlobal } from '@/utils/useGlobal';
import EFVideoModal from '@/components/UI/EFVideoModal';

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

export default function Other() {
    const { Link } = useGlobal();
    const { locale } = useRouter();
    const [viewCount, setViewCount] = useState([]);

    const { t } = useLang('bladeroboticlawnmower.detail.kolSection');
    const [active, setActive] = useState(0);
    const [activeVideo, setActiveVideo] = useState(kolVideo[0]);
    const [videoModal, setVideoModal] = useState(false);

    const sliderData = [
        {
            avatarUrl: [require('@publicLocal/blade/detail/pc/kol_avatar_1.webp'), require('@publicLocal/blade/detail/pc/kol_avatar_1.png')],
            title: t('kol_1.title'),
            desc: t('kol_1.name'),
            imgUrl: [require('@publicLocal/blade/detail/pc/kol_1.webp'), require('@publicLocal/blade/detail/pc/kol_1.jpg')],
        },
        {
            avatarUrl: [require('@publicLocal/blade/detail/pc/kol_avatar_2.webp'), require('@publicLocal/blade/detail/pc/kol_avatar_2.png')],
            title: t('kol_2.title'),
            desc: t('kol_2.name'),
            imgUrl: [require('@publicLocal/blade/detail/pc/kol_2.webp'), require('@publicLocal/blade/detail/pc/kol_2.jpg')],
        },
        {
            avatarUrl: [require('@publicLocal/blade/detail/pc/kol_avatar_3.webp'), require('@publicLocal/blade/detail/pc/kol_avatar_3.png')],
            title: t('kol_3.title'),
            desc: t('kol_3.name'),
            imgUrl: [require('@publicLocal/blade/detail/pc/kol_3.webp'), require('@publicLocal/blade/detail/pc/kol_3.jpg')],
            video: 'https://www.youtube.com/watch?v=wDhMqwljVj8',
        },
    ];

    const handlePlayVideo = (index: number) => {
        setActiveVideo(kolVideo[index]);
        if (active === 3) {
            return;
        } else {
            setVideoModal(true);
        }
    };

    useEffect(() => {
        queryArr();
    }, []);

    const queryArr = async () => {
        const countStatus = {};

        const allCountPromise = await Promise.all(
            ['CSWv2OT9rNg', 'tWVT6DlO3tw', 'wDhMqwljVj8'].map(async (item) => {
                return await request({
                    method: 'GET',
                    url: '/api/getViewCount',
                    query: {
                        videoId: item,
                        locale,
                    },
                });
            }),
        );

        allCountPromise.forEach((item, index) => {
            if (item.data.code === '0') {
                countStatus[index] = item.data.data;
            }
        });
        setViewCount(countStatus);
    };

    return (
        <div className={`${css['blade-I']}`}>
            <div className="bladei-title bladei-title-b">{t('title')}</div>
            <div className="bladei-b-swiper">
                <Swiper
                    modules={[Pagination]}
                    onSlideChange={(swiper: any) => setActive(swiper?.activeIndex)}
                    navigation={true}
                    pagination={false}
                    spaceBetween={60}
                    width={640}
                    slidesPerView={'auto'}
                    grabCursor
                >
                    {sliderData.map((sliderItem, index) => (
                        <>
                            <SwiperSlide key={index} className={`bladei-item ${index === active ? 'bladei-active-item' : ''}`}>
                                {index === 2 ? (
                                    <Link className="video-box" href={sliderItem.video}>
                                        <div className="bladei-img">
                                            <NextImage webpSrc={sliderItem.imgUrl[0]} src={sliderItem.imgUrl[1]} />
                                        </div>
                                        <div className="video-icon-box">
                                            <span className="video-svg"></span>
                                        </div>
                                    </Link>
                                ) : (
                                    <div className="video-box" onClick={() => handlePlayVideo(index)}>
                                        <div className="bladei-img">
                                            <NextImage webpSrc={sliderItem.imgUrl[0]} src={sliderItem.imgUrl[1]} />
                                        </div>
                                        <div className="video-icon-box">
                                            <span className="video-svg"></span>
                                        </div>
                                    </div>
                                )}

                                <div className="bladei-user">
                                    <div className="bladei-user-l">
                                        <NextImage webpSrc={sliderItem.avatarUrl[0]} src={sliderItem.avatarUrl[1]} />
                                    </div>
                                    <div className="bladei-user-r">
                                        <div className="bladei-user-line1">{sliderItem.title}</div>
                                        <div className="bladei-user-line2">{sliderItem.desc}</div>

                                        <div className="bladei-user-line3">
                                            <span className="view-svg"></span>
                                            <span>{`${viewCount[index]} views`}</span>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        </>
                    ))}
                </Swiper>
            </div>
            <EFVideoModal visible={videoModal} source={activeVideo} onClose={() => setVideoModal(false)} playerType="YouTube" />
        </div>
    );
}
